import React, { useEffect, useState } from 'react';
import { deacService } from '../../../services/central-api/deac';
import Toast from 'react-native-toast-message';
import { translate } from '../../../services/translate';
import { FlatList, View } from 'react-native';
import { MyCheckbox } from '../../../components/MyCheckbox';
import { useStyles } from 'react-native-unistyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { WindowInformation } from '../../../services/window-information';
import Badge from '../../../components/Badge';
import { DEFAULT_PASTEL_COLORS, DEFAULT_PASTEL_TEXT_COLORS } from '../../../styles/colorPalettes';

interface VacancyTagsInputs {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    disabled?: boolean;
}

export default function VacancyTagsInputs({ setValue, value, disabled }: VacancyTagsInputs) {
    const { theme } = useStyles();
    const windowInfo = WindowInformation();

    const [vacancyTags, setVacancyTags] = useState<VacancyTag[]>([]);
    async function getVacancyTags() {
        try {
            const response = await deacService.getTagsSimplified();
            setVacancyTags(response);
        } catch (err) {
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    useEffect(() => {
        getVacancyTags();
    }, []);

    function getVacancyTagTextColor(color: string) {
        const index = DEFAULT_PASTEL_COLORS.indexOf(color);
        return DEFAULT_PASTEL_TEXT_COLORS[index];
    }

    const numColumns = windowInfo.isMobile ? 2 : 4;
    const numberOfRows = Math.ceil(vacancyTags.length / numColumns);

    function renderVacancyTagItem(item: VacancyTag, index: number) {
        const colIndex = index - ((numberOfRows - 1) * numColumns);
        const isLastElement = index === vacancyTags.length - 1;
        return <MyCheckbox
            label={<Badge mode='ROUNDED' backgroundColor={item.color} textColor={getVacancyTagTextColor(item.color)}>{item.name}</Badge>}
            style={isLastElement ? { flex: numColumns - colIndex } : { flex: 1 }}
            checked={value.includes(item.id)}
            disabled={disabled}
            textContainerStyle={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}
            setChecked={(val => {
                if (val) {
                    setValue([...value, item.id]);
                } else {
                    setValue(value.filter(v => v != item.id));
                }
            })}
            customIcon={<FontAwesomeIcon icon={faCheck} fontSize={10} color={theme.colors.white['500']} />}
            checkBoxStyle={{
                backgroundColor: value.includes(item.id)
                    ? disabled ? theme.colors.primary['200'] : theme.colors.primary['500']
                    : disabled ? theme.colors.neutral['200'] : 'transparent',
                borderWidth: 1,
                borderColor: theme.colors.neutral['300']
            }}
        />;
    }

    return (
        <View style={{ flexDirection: 'row', gap: 45, flexWrap: 'wrap' }}>
            <FlatList
                data={vacancyTags}
                renderItem={(item) => renderVacancyTagItem(item.item, item.index)}
                keyExtractor={(item, index) => `${item}-${index}`}
                numColumns={numColumns}
                scrollEnabled={true}
                style={{ maxHeight: 175 }}
                contentContainerStyle={{ justifyContent: 'space-around', gap: 10 }}
                columnWrapperStyle={numColumns > 1 ? { justifyContent: 'space-around' } : undefined}
            />
        </View>
    );
}
